import { render, staticRenderFns } from "./SubCategoryTagsInput.component.vue?vue&type=template&id=78476c6e&scoped=true&"
import script from "./SubCategoryTagsInput.component.vue?vue&type=script&lang=js&"
export * from "./SubCategoryTagsInput.component.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryTagsInput.component.vue?vue&type=style&index=0&id=78476c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78476c6e",
  null
  
)

export default component.exports